import gtag from 'ga-gtag';
import { isUser } from './identity.js';

export function setGtag(action, category, label, value, notSet = false) {
  if (notSet) return;
  if (isUser()) {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
}
